import Api from './BaseRequest';

const Classlist = (exclude) => {
    if (exclude) {
        return Api.Get('/api/user/classlist', { exclude })
    }
    return Api.Get('/api/user/classlist')
};

const SetClass = (class_id) => {
    return Api.Post('/api/user/set_class', { class_id })
};

const TeacherList = () => {
    // Gets list of teachers for current student class
    return Api.Get('/api/user/teacherlist')
}

// Classes the student can set the theory exam passed date on
const TheoryClasslist = () => {
    return Api.Get('/api/user/theory/classlist')
};

const SetTheoryPassed = (data) => {
    return Api.Post('/api/user/theory/passed', data)
};

const GetUserDetails = () => {
    return Api.Get('/api/user')
}

const PostUserDetails = (data) => {
    return Api.Post('/api/user', data)
}

export default {
    Classlist,
    TeacherList,
    SetClass,
    TheoryClasslist,
    SetTheoryPassed,
    GetUserDetails,
    PostUserDetails,
}
